import { Container } from '@/components';
import Table from '@/components/common/table/Table';
import { usePaymentReminder } from '@/context/paymentReminderContext/PaymentReminderContextProvider';
import React, { useEffect } from 'react';
import { MdReplay } from 'react-icons/md';
import { SiMicrosoftexcel } from 'react-icons/si';

const DetailTable = ({ closeModal, batchId, status }) => {
  const {
    getLogsListByBatchIdAndSendStatusApi,
    selectedBatchIdData,
    setSelectedBatchIdData,
    resendEmailRecordsAPI,
    dowloadLogExcelFileAPI,
  } = usePaymentReminder();

  useEffect(() => {
    getLogsListByBatchIdAndSendStatusApi(batchId, status);
  }, [batchId, status]);

  const column = [
    { header: 'Customer Code', field: 'customer.customerCode' },
    { header: 'Customer Name', field: 'customer.customerName' },
    {
      header: 'Email',
      render: (cust) => {
        const emails = [cust?.email1, cust?.email2].filter(Boolean);
        return emails.join(', ');
      },
    },
    { header: 'Status', field: 'sendStatus' },
    { header: 'Remark', field: 'remark' },
    {
      header: 'Date',
      render: (row) => {
        if (!row?.date) return '';
        const dateObj = new Date(row.date);
        if (isNaN(dateObj)) return row.date;
        // Format as dd/mm/yyyy
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}/${month}/${year}`;
      },
    },
  ];
  const handleResend = () => {
    resendEmailRecordsAPI(batchId, handleClose);
  };

  const handleDownloadExcel = () => {
    // Placeholder: implement actual Excel export logic here
    // For example, you might call an API or utility function to export selectedBatchIdData
    // exportToExcel(selectedBatchIdData, `Batch_${batchId}_logs.xlsx`);
    dowloadLogExcelFileAPI(batchId, status, handleClose);
  };

  const handleClose = () => {
    closeModal();
    setSelectedBatchIdData([]); // Clear the selected batch data when closing the modal
  };

  return (
    <Container>
      <div className="flex justify-end mb-2 space-x-2 m-2">
        {status === 'Failed' && (
          <button
            onClick={handleResend}
            title="Resend Emails"
            className="flex items-center px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            <MdReplay className="h-5 w-5 mr-1" />
            Resend
          </button>
        )}

        <button
          onClick={handleDownloadExcel}
          title="Download Excel"
          className="flex items-center px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600"
        >
          <SiMicrosoftexcel className="h-5 w-5 mr-1" />
          Download Excel
        </button>
      </div>
      {Array.isArray(selectedBatchIdData) &&
      selectedBatchIdData.length === 1 &&
      typeof selectedBatchIdData[0] === 'string' &&
      selectedBatchIdData[0].toLowerCase() === 'no data found' ? (
        <div className="text-center text-red-500">
          No Data Found for this Batch Id
        </div>
      ) : (
        <>
          <Table
            isForSorting={false}
            data={selectedBatchIdData}
            columns={column}
          />
        </>
      )}
    </Container>
  );
};

export default DetailTable;
